<template>
  <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
    <a
      href="#"
      @click="toggleSidebar"
      class="p-0 nav-link"
      :class="getDarkMode ? 'text-white' : 'text-default'"
      id="iconNavbarSidenav"
    >
      <div class="sidenav-toggler-inner">
        <i
          class="sidenav-toggler-line"
          :class="getDarkMode ? 'bg-white' : 'text-default'"
        ></i>
        <i
          class="sidenav-toggler-line"
          :class="getDarkMode ? 'bg-white' : 'text-default'"
        ></i>
        <i
          class="sidenav-toggler-line"
          :class="getDarkMode ? 'bg-white' : 'text-default'"
        ></i>
      </div>
    </a>
  </li>
</template>



<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "navbar-sidebar-toogler",
  methods: {
    ...mapMutations([
      "navbarMinimize",
      "setShowSidenavMutation",
    ]),
    toggleSidebar() {
      this.setShowSidenavMutation(!this.getShowSidenav);
      this.navbarMinimize();
    },
  },
  computed: {
    ...mapGetters(["getDarkMode", "getShowSidenav"]),
  },
};
</script>
